import { IonItem, IonList } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import Trans from 'util/Trans';

interface OptionsProps {
  onHide: () => void;
  logOut: () => void;
  changeUsername?: () => void;
  checkUpdates?: () => void;
}

const OptionsPopOver: React.FC<OptionsProps> = ({
  onHide,
  logOut,
  changeUsername,
  checkUpdates,
}) => {
  return (
    <IonList className="popup-menu" lines="none">
      <IonItem
        detail={false}
        button
        onClick={() => {
          changeUsername?.();
          onHide();
        }}
      >
        <Trans i18nKey="CHANGE_USERNAME">Username ändern</Trans>
      </IonItem>
      <IonItem
        detail
        href={'https://spinnax.com/datenschutzerklaerung-der-spinnax-app/'}
      >
        <Trans i18nKey="PRIVACY_POLICY">Datenschutz</Trans>
      </IonItem>
      <IonItem detail href={'https://spinnax.com/manual-freak/'}>
        <Trans i18nKey="INSTRUCTIONS">Anleitung</Trans>
      </IonItem>
      <IonItem detail href={'https://spinnax.com'}>
        <Trans i18nKey="SHOP">Spinnax Shop</Trans>
      </IonItem>
      <IonItem
        detail={false}
        button
        onClick={() => {
          if (checkUpdates) {
            checkUpdates?.();
            onHide();
          }
        }}
      >
        {!checkUpdates && <div id="pop-up-menu-overlay"></div>}
        <span
          style={{ textDecoration: checkUpdates ? undefined : 'line-through' }}
        >
          <Trans i18nKey="SEARCH_FOR_UPDATES">Nach Updates suchen</Trans>
        </span>
      </IonItem>
      <IonItem
        detail={false}
        button
        onClick={() => {
          logOut();
          onHide();
        }}
      >
        <Trans i18nKey="LOGOUT">Ausloggen</Trans>
      </IonItem>
    </IonList>
  );
};

export default OptionsPopOver;
